import React from "react";
import ActivityContainerComponent from "../components/activity/activityContainer";

export const ActivityPage = () => {
  return (
    <ActivityContainerComponent />
  );
};